import { render, staticRenderFns } from "./RootParkingOccupancy.vue?vue&type=template&id=2514e105&scoped=true"
import script from "./RootParkingOccupancy.vue?vue&type=script&lang=js"
export * from "./RootParkingOccupancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514e105",
  null
  
)

export default component.exports